import React, { useId } from 'react';
type HeroEmblemProps = {
  /** When provided, the typeset emblem is replaced by this logo image. */
  logoSrc?: string;
  className?: string;
};
const cream = 'rgb(var(--color-cream))';
const copper = 'rgb(var(--color-copper))';
const gold = 'rgb(var(--color-gold))';
export function HeroEmblem({
  logoSrc,
  className = ''
}: HeroEmblemProps) {
  const arcId = `emblem-arc-${useId().replace(/:/g, '')}`;
  return <div className={`relative aspect-square rounded-full bg-gold-gradient p-[clamp(2px,0.12vw,4px)] shadow-[0_0_5vmin_0.5vmin_rgba(212,162,76,0.22),0_0_13vmin_3vmin_rgba(212,162,76,0.10)] ${className}`} data-id="element-11" data-mp="2h3mkq3x8sc0h">
      <div className="relative h-full w-full overflow-hidden rounded-full bg-night" data-id="element-12" data-mp="2pwpx08w5iitj">
        {logoSrc ? <img src={logoSrc} alt="Oh My Tacos! logo" className="h-full w-full object-cover" data-id="element-13" data-mp="2l351qoly02y1" /> : <svg viewBox="0 0 400 400" className="h-full w-full" role="img" aria-label="Oh My Tacos! — Hecho con amor y sabor" data-id="element-14" data-mp="1xcr8wvvja02e">
            <defs data-id="element-15" data-mp="1iwyq69dz27y7">
              <path id={arcId} d="M 56 200 A 144 144 0 0 0 344 200" fill="none" data-id="element-16" data-mp="1ive4785q3xby" />
            </defs>

            <circle cx="200" cy="200" r="182" fill="none" stroke={gold} strokeOpacity="0.35" strokeWidth="1" data-id="element-17" data-mp="1ntyw8katnapb" />

            {/* Copper burst at the top-left of the O */}
            <g stroke={copper} strokeWidth="5" strokeLinecap="round" data-id="element-18" data-mp="1xllbqsu6zvxv">
              <line x1="80" y1="104" x2="68" y2="91" data-id="element-19" data-mp="zzfoxrxr9tmc" />
              <line x1="91" y1="98" x2="88" y2="81" data-id="element-20" data-mp="100qt3sv453dz" />
              <line x1="74" y1="115" x2="57" y2="112" data-id="element-21" data-mp="14y8rwqff2289" />
            </g>

            {/* OH MY — tall condensed capitals */}
            <g transform="translate(200 198) scale(1 1.4)" data-id="element-22" data-mp="19v8yr3k3b90f">
              <text x="0" y="0" textAnchor="middle" fontFamily="Oswald, sans-serif" fontWeight="600" fontSize="78" textLength="218" lengthAdjust="spacingAndGlyphs" fill={cream} data-id="element-23" data-mp="1evwwe82tqo3m">
                OH MY
              </text>
            </g>

            {/* TACOS! — western serif */}
            <text x="200" y="270" textAnchor="middle" fontFamily="Rye, Georgia, serif" fontSize="52" textLength="240" lengthAdjust="spacingAndGlyphs" fill={cream} data-id="element-24" data-mp="l97qjf4rids3">
              TACOS!
            </text>

            {/* Curved tagline along the bottom */}
            <text fontFamily="Oswald, sans-serif" fontWeight="500" fontSize="15" letterSpacing="4" fill={copper} data-id="element-25" data-mp="2kjcnd4p58pt">
              <textPath href={`#${arcId}`} startOffset="50%" textAnchor="middle" data-id="element-26" data-mp="gbo59v9nd0qn">
                · HECHO CON AMOR Y SABOR ·
              </textPath>
            </text>
          </svg>}
      </div>
    </div>;
}